module.exports = __webpack_public_path__ + "img/kefuxitong.88a13563.png";